import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets';
import LineItems from '../LineItems/LineItems';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { useTransactionLimits } from '../../hooks/useTransactionLimits';
import FutureChargesValidationMessages from './FutureChargesValidationMessages';
import { useValidationErrors } from '../../hooks/useValidationErrors';
import { MAX_RECURRING_SUBTOTAL_EXCEEDED, MIN_RECURRING_SUBTOTAL_NOT_REACHED } from '../../constants/ValidationErrors';
import { getShowAllErrors } from '../../state/errorMessagesSlice';
import { useSelector } from 'react-redux';
import { getLineItemBlurs } from '../../state/lineItemBlursSlice';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FutureCharges = ({
  futureStartDateLineItems,
  currencyCode,
  lineItemErrors,
  readOnly,
  selectionToggles,
  selectedItems,
  sessionOpen,
  isZeroCheckout,
  lineItemTaxLabel,
  shouldDisplayLineItemTaxes,
  areTaxLabelsDifferent
}) => {
  const {
    formState
  } = usePaymentFormContext();
  const paymentMethod = formState.get('paymentMethod');
  const {
    limits
  } = useTransactionLimits();
  const minimumAmount = limits === null || limits === void 0 ? void 0 : limits.minimumAmountForPaymentMethod[paymentMethod];
  const maximumAmount = limits === null || limits === void 0 ? void 0 : limits.maximumAmountForPaymentMethod[paymentMethod];
  const {
    subtotalsValidationErrors
  } = useValidationErrors();
  const showAllErrors = useSelector(getShowAllErrors);
  const lineItemBlurs = useSelector(getLineItemBlurs);
  const futureSubtotalValidationErrors = subtotalsValidationErrors.filter(error => {
    var _error$context;
    return (_error$context = error.context) === null || _error$context === void 0 || (_error$context = _error$context.initialPaymentType) === null || _error$context === void 0 ? void 0 : _error$context.includes('FUTURE_START_DATE');
  });
  const shouldShowFutureChargesRecurringMessage = showAllErrors || futureStartDateLineItems.some(lineItem => lineItemBlurs[lineItem.id]);
  const isRecurringTotalBelowMin = useMemo(() => shouldShowFutureChargesRecurringMessage && futureSubtotalValidationErrors.some(err => err.subCategory === MIN_RECURRING_SUBTOTAL_NOT_REACHED), [futureSubtotalValidationErrors, shouldShowFutureChargesRecurringMessage]);
  const isRecurringTotalAboveMax = useMemo(() => shouldShowFutureChargesRecurringMessage && futureSubtotalValidationErrors.some(err => err.subCategory === MAX_RECURRING_SUBTOTAL_EXCEEDED), [futureSubtotalValidationErrors, shouldShowFutureChargesRecurringMessage]);
  const tooltipMessage = useMemo(() => isZeroCheckout ? 'payments.futureCharges.zeroCheckoutTooltip' : 'payments.futureCharges.headerTooltip', [isZeroCheckout]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      backgroundColor: "fill-tertiary-default",
      paddingInline: "600",
      paddingBlock: "300",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.futureCharges.header"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipMessage,
          options: {
            count: futureStartDateLineItems.length
          }
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "100",
          color: "icon-core-default"
        })
      })]
    }), /*#__PURE__*/_jsx(LineItems, {
      selectionToggles: selectionToggles,
      selectedItems: selectedItems,
      lineItems: futureStartDateLineItems,
      currencyCode: currencyCode,
      readOnly: readOnly,
      lineItemErrors: lineItemErrors,
      sessionOpen: sessionOpen,
      lineItemTaxLabel: lineItemTaxLabel,
      shouldDisplayLineItemTaxes: shouldDisplayLineItemTaxes,
      areTaxLabelsDifferent: areTaxLabelsDifferent
    }), /*#__PURE__*/_jsx(FutureChargesValidationMessages, {
      minimumAmount: minimumAmount,
      maximumAmount: maximumAmount,
      currencyCode: currencyCode,
      isRecurringTotalBelowMin: isRecurringTotalBelowMin,
      isRecurringTotalAboveMax: isRecurringTotalAboveMax,
      topMargin: (isRecurringTotalAboveMax || isRecurringTotalBelowMin) && futureStartDateLineItems.length === 1 ? '-400' : undefined
    }), /*#__PURE__*/_jsx(HR, {
      distance: "md",
      margin: "0"
    })]
  });
};
export default FutureCharges;